import styles from './publicitat.module.scss';
import clsx from 'clsx';

const PublicitatWrapper = ({ PublicitatComponent, ...props }) => {
    const { format } = props;
    const stylesPublicitatWrapper = clsx({
        [styles.publicitatWrapper]: true,
        [styles[format]]: true
    });
    return (
        <div className={stylesPublicitatWrapper} data-testid={`publicitatWrapper-${format}`}>
            <div className={styles.wrapperPlaceHolder} />
            <div className={styles.wrapperContingut}>
                <PublicitatComponent {...props} />
            </div>
        </div>
    );
};

export default PublicitatWrapper;
